import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
`;

export const Content = styled.section`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 93px 0;

  @media screen and (max-width: 500px) {
    padding: 48px 0;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 500px) {
    padding: 0 32px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 740px;
  margin-bottom: 88px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 28px;
  color: #111;

  .drop-caps:first-letter {
    font-size: 4em;
    float: left;
    padding: 0 10px 0 0;
    font-family: ${fonts.BentonSansWideBlack};
    line-height: 1em;
  }

  p {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #111;
    text-decoration: underline;
  }

  @media screen and (max-width: 500px) {
    padding: 0 32px;
    margin-bottom: 56px;
    line-height: 26px;
  }
`;

export const WrapperWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
`;

export const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;
  margin-bottom: 88px;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media screen and (max-width: 500px) {
    margin-bottom: 56px;
  }
`;

export const Separator = styled.div`
  width: 76px;
  height: 5px;
  background-color: #111;
  margin-bottom: 88px;
`;
